/**
 * Who a member of the family can be. A label is free text; these are the
 * ones offered first, on sign-up and in the profile, so a grandparent or a
 * nanny does not have to type past "mom" and "dad".
 */
export const ROLE_SUGGESTIONS = ['mom', 'dad', 'grandma', 'grandpa', 'nanny', 'teacher', 'aunt', 'uncle'] as const

export function isSuggestedRole(label: string): boolean {
  return (ROLE_SUGGESTIONS as readonly string[]).includes(label.trim().toLowerCase())
}

/**
 * The invite link: the family code in a URL someone can tap. It opens the web
 * app on "Join your family" with the code already typed, so the person joining
 * only names themselves. The code alone still works everywhere it did.
 */
export const INVITE_ORIGIN = 'https://sapling.day'

/** Sapling Family on the App Store. */
export const APP_STORE_URL = 'https://apps.apple.com/app/sapling-family/id6801245238'

export function inviteLink(joinCode: string): string {
  return `${INVITE_ORIGIN}/?join=${encodeURIComponent(joinCode.trim().toUpperCase())}`
}

/** The family code in an invite link's query string, if there is one. */
export function joinCodeFromSearch(search: string): string | null {
  const code = new URLSearchParams(search).get('join')?.replace(/[^0-9a-z]/gi, '').toUpperCase()
  return code || null
}

/** What goes out with the link when it is shared or copied as a message. */
export function inviteMessage(joinCode: string, childName?: string): string {
  return `Join ${childName ? `${childName}'s` : 'our'} family on Sapling: ${inviteLink(joinCode)}\nOr choose "Join with a code" and type ${joinCode}.`
}
